module.exports = __webpack_public_path__ + "images/industrial-5-4100bfec3b7fdf44922c7885bf370d2a.jpg";